module.exports = __webpack_public_path__ + "static/Warnings_app_screen-bd8837c996c90d8863bc730826adcfa4.png";